import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {createParentPositions, SIDE_POSITIONS, VANITY_TYPES} from "../../constants";
import {updateSinkWithNewFeature} from "../../../lookNavigation/lookNavigationFunctions";

export default class VanityConsole extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_console';
    this.partName = 'Console';
    this.translateId = "visualizer.bathroom.vanity.vanity_console";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    this.toggleLayerPositions();
  }

  handleClick(ignoreLocked) {
    const vanityParent = this.getParent().getParent();
    vanityParent.vanity_type = VANITY_TYPES.vanity_console;
    super.handleClick(ignoreLocked);
    updateSinkWithNewFeature(this);
    vanityParent.updateVanityParts();
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return vanityParent.vanity_type !== VANITY_TYPES.vanity_console && !!this.activeFeature
  }

  // getArrayOfConditions() {
  //   const conditions = super.getArrayOfConditions();
  //   const activeMatchingSink = this.getParent().getActiveSkuFromRelatedItem("vanity_sink");
  //   if (activeMatchingSink) {
  //     conditions.push({
  //       propName: "MatchingFeature",
  //       propValue: activeMatchingSink
  //     });
  //   }
  //   return conditions
  // }

  canDisplayDemoPoint(parentObject) {
    return this.getParent().vanity_type === VANITY_TYPES.vanity_console && (parentObject.layerPosition !== SIDE_POSITIONS[0])
  }

}
